import React from "react";
import {CopyrightSharp} from "@mui/icons-material";
import {Typography} from "@mui/material";
import {B} from "../../build";
import {useStores} from "../../stores";
import {environment} from "../../env";


export const MainFooter: React.FC = () => {
    const {p} = useStores()
    const year = new Date().getFullYear();
    return <Typography
        id="main-footer"
        className="mithra-footer"
        variant="body1"
        component="footer"
        sx={{
            color: (theme) => theme.palette.grey[200],
            marginTop: (theme) => theme.spacing(2),
            display: 'flex',
            justifyContent: "center",
            alignItems: "center",
        }}>
        <CopyrightSharp sx={{
            fontSize: '1em',
            marginRight: '0.2em',
        }}>(c)</CopyrightSharp>
        Mithra-AI Solutions B.V. {year + ' '}
        - version: {B.APP_VERSION}
        {p.p.enableBackendStatusPage && environment.statusPageUrl &&
            <>
                {' - '}
                <a style={{marginLeft: '.3em'}} href={environment.statusPageUrl} target="_blank" rel="noreferrer">
                    service status
                </a>
            </>
        }
    </Typography>;
};
